import React, { Component } from 'react';
import PropTypes from 'prop-types';

import starActive from '../../images/icons/icon_reviewstar_active.png';
import starInactive from '../../images/icons/icon_reviewstar_inactive.png';

const ratingOptions = [
  1,
  2,
  3,
  4,
  5
];

class RatingWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 5,
      hoverRating: 0,
    };
    this.onChange = this.onChange.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.displayStar = this.displayStar.bind(this);
  }

  onChange(ratingVal) {
    this.setState({
      rating: ratingVal,
    });
    const { customOnChange, customFieldValue } = this.props;
    if(customOnChange && customFieldValue) {
      //Formik's setFieldValue
      customOnChange(customFieldValue, ratingVal, false);
    }
  }

  onMouseOver(rating) {
    this.setState({
      hoverRating: rating,
    });
  }

  onMouseLeave() {
    this.setState({
      hoverRating: 0,
    });
  }

  displayStar(ratingVal) {
    const { rating, hoverRating } = this.state;
    if(hoverRating !== 0 && ratingVal <= hoverRating) {
      return starActive;
    } else if(hoverRating === 0 && ratingVal <= rating) {
      return starActive;
    }
    return starInactive;
  }

  render() {
    return (
      <div
        className="fe-rating-widget"
        onMouseLeave={this.onMouseLeave}
      >
        {ratingOptions.map((ratingOption) => (
          <span
            key={ratingOption}
            className="fe-rating-star widget"
            onClick={() => this.onChange(ratingOption)}
            onMouseOver={() => this.onMouseOver(ratingOption)}
          >
            <img src={this.displayStar(ratingOption)} alt=""/>
          </span>
        ))}
      </div>
            
    );
  }
}

RatingWidget.propTypes = {
  customFieldValue: PropTypes.string,
  customOnChange: PropTypes.func,
};

export default RatingWidget;